import { HarmReportAdvancedFilters } from '../pages/harmReports/harmReports.type';

export const hasActiveAdvancedFilters = (
  filters: HarmReportAdvancedFilters,
): boolean => {
  return Boolean(
    filters.timeCreatedFrom ||
    filters.timeCreatedUntil ||
    filters.playerNo ||
    (filters.harmObserved && filters.harmObserved.length > 0) ||
    filters.harmInstance ||
    (filters.interventionDecision && filters.interventionDecision.length > 0) ||
    (filters.interventionStatus && filters.interventionStatus.length > 0) ||
    filters.reviewDeadline ||
    filters.interventionDeadline ||
    filters.totalInterventionsOffered ||
    filters.totalInterventionsRequested ||
    filters.createdBy ||
    filters.reviewedBy ||
    filters.dateReviewedFrom ||
    filters.dateReviewedTo ||
    (filters.reviewStatus && filters.reviewStatus.length > 0),
  );
};
